import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { NoResultsProps } from './interface';

const NoResults = ({
  illustration,
  info,
  resetLabel,
  onReset,
  containerStyle,
}: NoResultsProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.container} style={containerStyle}>
      {illustration}
      <Typography variant="body1" className={classes.info}>
        {info}
      </Typography>
      <Typography
        variant="body1"
        className={classes.resetButton}
        onClick={onReset}
      >
        {resetLabel}
      </Typography>
    </Box>
  );
};

export default NoResults;
